import React from "react";
import PropTypes from "prop-types";
import { Box, Chip, Collapse, IconButton, Paper, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import TicketChat from "./ticketChat";
import {
  formatTicketDate,
  getTicketStateColor,
  getTicketStateLabel,
} from "../../../services/ticketUtils";

const TicketCard = ({ ticket, expanded, onToggle, disabled, onMessagesRead }) => {
  const showUnread = ticket.unreadCount > 0
    && (ticket.state === "in-lavorazione" || ticket.state === "chiuso");

  return (
    <Paper sx={{ mb: 2, borderRadius: "12px", overflow: "hidden", backgroundColor: "#fff" }}>
      <Box
        onClick={onToggle}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          justifyContent: "space-between",
          gap: 2,
          px: 3,
          py: 2,
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Rubik",
            fontWeight: "bold",
            color: "#0b3d87",
            flex: 1,
            minWidth: 0,
            width: { xs: "100%", md: "auto" },
            wordBreak: "break-word",
          }}
        >
          {ticket.subject}
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          flexShrink={0}
          flexWrap="wrap"
          width={{ xs: "100%", md: "auto" }}
          justifyContent={{ xs: "flex-start", md: "flex-end" }}
        >
          {showUnread ? (
            <Chip
              size="small"
              label={ticket.unreadCount}
              sx={{ fontFamily: "Rubik", backgroundColor: "#e00036", color: "#fff", fontWeight: 700 }}
            />
          ) : null}
          <Chip
            size="small"
            label={getTicketStateLabel(ticket.state)}
            sx={{
              fontFamily: "Rubik",
              fontWeight: 700,
              backgroundColor: getTicketStateColor(ticket.state),
              color: "#fff",
            }}
          />
          <Chip
            size="small"
            variant="outlined"
            label={formatTicketDate(ticket.createdAt)}
            sx={{ fontFamily: "Rubik", borderColor: "#0b3d87", color: "#0b3d87" }}
          />
          <IconButton size="small" aria-label={expanded ? "Comprimi ticket" : "Espandi ticket"}>
            {expanded ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>
      </Box>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Box sx={{ px: 3, pb: 3, pt: 1 }}>
          <TicketChat ticket={ticket} disabled={disabled} onMessagesRead={onMessagesRead} />
        </Box>
      </Collapse>
    </Paper>
  );
};

TicketCard.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    createdAt: PropTypes.any,
    unreadCount: PropTypes.number,
    description: PropTypes.string,
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onMessagesRead: PropTypes.func,
};

TicketCard.defaultProps = {
  disabled: false,
  onMessagesRead: null,
};

export default TicketCard;
